import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MessageCircle, Mic } from "lucide-react";
import { openVadimChat } from "@/components/VadimChat";

// "Snakk med kundeservice" call-to-action + explanatory copy.
// Points to the browser-based ElevenLabs voice/chat assistant, with a clear
// fallback to the contact form. Reusable on Home and Kontakt.
export default function CustomerServiceCTA({ dark = false }) {
  return (
    <section className={dark ? "py-16 md:py-20 bg-[#3D2314]" : "py-16 md:py-24 bg-[#FFF8F0]"} data-testid="cs-assistant-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#D4A574]/20 mb-5">
          <Mic className={`h-7 w-7 ${dark ? "text-[#D4A574]" : "text-[#3D2314]"}`} />
        </div>
        <h2 className={`text-3xl font-bold mb-4 font-display ${dark ? "text-white" : "text-[#3D2314]"}`}>Snakk med kundeservice</h2>
        <p className={`mb-6 ${dark ? "text-white/80" : "text-[#1A1A1A]/70"}`}>
          Vadim er vår digitale kundemedarbeider (AI). Velg om du vil skrive eller snakke.
        </p>
        <div className={`grid sm:grid-cols-2 gap-4 text-sm text-left max-w-2xl mx-auto mb-8 ${dark ? "text-white/75" : "text-[#1A1A1A]/70"}`}>
          <div data-testid="cs-text-info">
            <div className={`font-semibold mb-1 ${dark ? "text-white" : "text-[#3D2314]"}`}>Skriv med Vadim</div>
            Still spørsmål om tjenester, priser og innlevering, send en bookingforespørsel eller spør om status på reparasjonen etter identitetskontroll. Norsk, engelsk eller russisk.
          </div>
          <div data-testid="cs-voice-info">
            <div className={`font-semibold mb-1 ${dark ? "text-white" : "text-[#3D2314]"}`}>Snakk med Vadim</div>
            Beskriv hva du trenger hjelp med i en samtale og få svar om tjenester, priser og innlevering. Krever saken en teknisk vurdering, kan Vadim ta imot opplysningene og sende dem videre til teknikeren. Booking og reparasjonsstatus: bruk Skriv med Vadim.
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => openVadimChat("text")} size="lg" className="bg-[#D4A574] hover:bg-[#D4A574]/90 text-[#3D2314] font-semibold gap-2" data-testid="cs-start-btn">
            <MessageCircle className="h-5 w-5" />Skriv med Vadim
          </Button>
          <Button onClick={() => openVadimChat("voice")} variant="outline" size="lg" className={`gap-2 ${dark ? "border-white text-white hover:bg-white/10 hover:text-white" : "border-[#3D2314] text-[#3D2314] hover:bg-[#3D2314]/5"}`} data-testid="cs-voice-btn">
            <Mic className="h-5 w-5" />Snakk med Vadim
          </Button>
          <Button asChild variant="outline" size="lg" className={dark ? "border-white text-white hover:bg-white/10 hover:text-white" : "border-[#3D2314] text-[#3D2314] hover:bg-[#3D2314]/5"}>
            <Link to="/kontakt-skjema" data-testid="cs-fallback-link">Eller skriv til oss</Link>
          </Button>
        </div>
        <p className={`text-xs mt-4 ${dark ? "text-white/50" : "text-[#1A1A1A]/50"}`}>
          Tekstchatten og talesamtalen åpnes fra Vadim-knappen nederst til høyre. Å dele kontaktinformasjon er valgfritt.
        </p>
      </div>
    </section>
  );
}
